import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <div className="content">
        <h1>Thanks for visiting!</h1>
        <p>This website is currently under construction</p>
      </div>
    </div>
  );
}

export default App;
